/**
 * Dev backend URL, baked into the JS bundle at build time. A physical phone
 * (Expo Go, or the exported web build opened in a phone browser) can't reach
 * the dev machine's `localhost` at all — it needs the machine's LAN IP, and
 * both devices must be on the same Wi-Fi/network. Run `ipconfig` (Windows) /
 * `ifconfig` (Mac/Linux) to find it if it changes.
 *
 * Exception: an Android *emulator* (not a real device) reaches the host via
 * the special alias '10.0.2.2' instead of the LAN IP.
 */
const LAN_IP = '192.168.1.51';
const DEV_HOST = LAN_IP;

/** Production web builds set EXPO_PUBLIC_API_ORIGIN='' (see .env.production) so
 * the app calls the API on the same origin it's served from — no IP/domain to
 * hardcode, and it keeps working after the backend moves behind a real domain.
 * eas.json's preview/production build profiles set EXPO_PUBLIC_API_ORIGIN to
 * the real production URL for native builds. If some OTHER build path (a
 * manual `expo run:android --variant release`, a future CI script) ever
 * forgets to set it, falling back to the dev machine's LAN IP would silently
 * ship a real user an app that can only ever reach the developer's home
 * Wi-Fi — every API call fails with no clue why. Only trust the LAN-IP
 * fallback in an actual dev build; otherwise fall back to the real backend. */
const envOrigin = process.env.EXPO_PUBLIC_API_ORIGIN;
const devFallback = __DEV__ ? `http://${DEV_HOST}:3000` : 'https://loot.com.vn';
export const SERVER_ORIGIN = envOrigin !== undefined ? envOrigin : devFallback;
export const API_BASE_URL = `${SERVER_ORIGIN}/api`;

export const COIN_LABEL = 'xu';

/** Photo URLs from the API are host-relative (e.g. "/uploads/x.jpg"); the
 * backend serves them from its origin, not from the Expo dev server. */
export function resolvePhotoUrl(url: string): string {
  return url.startsWith('http') ? url : `${SERVER_ORIGIN}${url}`;
}

/** CCCD/CMND photos aren't reachable via the public /uploads route (PII) —
 * they're only served through these authenticated endpoints. The token here
 * MUST be a short-lived, single-purpose photo token from
 * getIdentityPhotoToken()/getAdminIdentityPhotoToken() — NOT the session
 * token — since it's passed as a URL query param (the only way <Image>/<img>
 * can authenticate a request, having no way to attach a custom header) and
 * anything in a query string ends up in access/proxy logs. */
export function myIdentityPhotoUrl(photoToken: string): string {
  return `${API_BASE_URL}/users/me/identity-photo-file?token=${encodeURIComponent(photoToken)}`;
}

export function adminIdentityPhotoUrl(userId: string, photoToken: string): string {
  return `${API_BASE_URL}/users/admin/identity-verifications/${userId}/photo?token=${encodeURIComponent(photoToken)}`;
}

export function myTopupProofUrl(transactionId: string, photoToken: string): string {
  return `${API_BASE_URL}/wallet/me/topup-proof-file/${transactionId}?token=${encodeURIComponent(photoToken)}`;
}

export function adminTopupProofUrl(transactionId: string, photoToken: string): string {
  return `${API_BASE_URL}/wallet/admin/topups/${transactionId}/photo?token=${encodeURIComponent(photoToken)}`;
}
